import { Box, Divider, Drawer, IconButton, List, ListItem, ListItemText, Typography } from "@mui/material";
import { DAY_NIGHT_TEXT_COLOR, WeatherAlert } from "../types/Weather";
import { Close, WarningAmberOutlined } from "@mui/icons-material";
import { getLocalTimeString } from "../helpers/weather-helpers";

const TodayWeatherAlertsBottomDrawer = (
  { weatherAlerts,
    weatherAlertIndex,
    drawerOpen,
    setDrawerOpen
  }: {
    weatherAlerts: WeatherAlert[],
    weatherAlertIndex: number | undefined,
    drawerOpen: boolean,
    setDrawerOpen: (drawerOpen: boolean) => void,
  }) => {

  const list = () => {

    if (weatherAlertIndex === undefined) {
      return <></>;
    }

    const weatherAlert = weatherAlerts[weatherAlertIndex];
    return (
      <Box role="presentation" sx={{ paddingX: 2, backgroundColor: DAY_NIGHT_TEXT_COLOR }}>
        <Box display="flex" alignItems="stretch" sx={{ paddingY: 2 }}>
          <Box flexGrow={1} sx={{ textAlign: "center", paddingLeft: 5 }}>
            <WarningAmberOutlined sx={{ paddingTop: 2, fontSize: 40 }} />
            <Typography variant="h5"><strong>Weather Alert</strong></Typography>
          </Box>
          <Box >
            <IconButton onClick={() => { setDrawerOpen(false) }}>
              <Close />
            </IconButton>
          </Box>
        </Box>
        <Divider />

        <List>
          <ListItem disablePadding >
            <Box sx={{ paddingY: 2 }} >
              <ListItemText primary={<Typography><strong>{weatherAlert.description}</strong></Typography>} />
              <ListItemText primary={<Typography><strong>Severity:</strong> {weatherAlert.severity}</Typography>} />
            </Box>
          </ListItem>
          <Divider />
          <ListItem disablePadding >
            <Box sx={{ paddingY: 2 }} >
              <ListItemText primary={<Typography><strong>Affected Areas</strong></Typography>} />
              <ListItemText primary={<Typography>{weatherAlert.areaName}</Typography>} />
            </Box>
          </ListItem>
          <Divider />
          <ListItem disablePadding >
            <Box sx={{ paddingY: 2 }} >
              <ListItemText primary={<Typography><strong>Alert in Effect</strong></Typography>} />
              <ListItemText primary={
                <Typography>From {getLocalTimeString(weatherAlert.effectiveTime, weatherAlert.timezone)},
                  until {getLocalTimeString(weatherAlert.expireTime, weatherAlert.timezone)}</Typography>
              } />
            </Box>
          </ListItem>
          <Divider />
          <ListItem disablePadding >
            <Box sx={{ paddingY: 2 }} >
              <ListItemText primary={<Typography><strong>Description</strong></Typography>} />
              {weatherAlert.messages.map((msg, i) => (
                <ListItemText key={i} primary={<Typography sx={{ paddingBottom: 2 }}>{msg.text}</Typography>} />
              ))}
            </Box>
          </ListItem>
          <Divider />
          <ListItem disablePadding >
            <Box sx={{ paddingY: 2 }} >
              <ListItemText primary={<Typography><strong>Issued By</strong></Typography>} />
              <ListItemText primary={<Typography>{weatherAlert.source}</Typography>} />
              <ListItemText primary={<Typography>{getLocalTimeString(weatherAlert.issuedTime, weatherAlert.timezone)}</Typography>} />
            </Box>
          </ListItem>
        </List>

      </Box>
    );
  };

  return (
    <Drawer
      PaperProps={{ sx: { height: '90%' } }}
      sx={{ height: '100%' }}
      anchor="bottom"
      open={drawerOpen}
      onClose={() => setDrawerOpen(false)}
    >
      {list()}
    </Drawer>
  );
}

export default TodayWeatherAlertsBottomDrawer;